import { MadisonBlueButton } from '@mindmemobile/mm-shared-global';
import styled from 'styled-components';

export const DonationWrapper = styled.div`
    input[type='text'].styled-input:not(.price-selector-input, .amount-range),
    textarea.styled-input {
        width: 430px;
    }
    textarea {
        min-height: 100px;
    }
    .placeholder-check {
        height: 16px;
        width: 16px;
        margin-right: 8px;
        margin-bottom: 3px;
    }
    input.amount-range {
        width: 180px !important;
    }
    ${MadisonBlueButton} {
        width: 100%;
        padding: 8px;
    }
    .pricing-option-wrapper {
        max-width: 425px;
    }
`;
